import { apiFetch } from './client';

// #141 — Customer API: in-portal provisioning of customer intake clients
// (bcid-admin only). Proxies the Keycloak Admin API through the portal API
// (Keycloak is loopback-only). All calls 503 with "customer API management not
// configured" until the bcid-admin-svc credential is provisioned AND granted
// manage-clients; the page renders a not-configured banner in that case.

export interface IntakeClient {
  clientId: string;
  slug: string;
  customerId: string | null;
  enabled: boolean;
}

export async function listIntakeClients(): Promise<IntakeClient[]> {
  const res = await apiFetch<{ items: IntakeClient[] }>('/admin/intake-clients');
  return res.items;
}

export interface CreateIntakeClientResult {
  clientId: string;
  slug: string;
  customerId: string;
  /** The confidential client secret — returned exactly once, never stored. */
  clientSecret: string;
}

export async function createIntakeClient(
  input: { slug: string; customerId: string },
  idempotencyKey: string,
): Promise<CreateIntakeClientResult> {
  return apiFetch<CreateIntakeClientResult>('/admin/intake-clients', {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(input),
  });
}

export interface RotateSecretResult {
  clientId: string;
  /** The new confidential client secret — returned exactly once. */
  clientSecret: string;
}

export async function rotateIntakeClientSecret(clientId: string, idempotencyKey: string): Promise<RotateSecretResult> {
  return apiFetch<RotateSecretResult>(`/admin/intake-clients/${encodeURIComponent(clientId)}/rotate-secret`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
  });
}

export async function setIntakeClientEnabled(clientId: string, enabled: boolean): Promise<void> {
  await apiFetch<{ ok: boolean }>(`/admin/intake-clients/${encodeURIComponent(clientId)}/enabled`, {
    method: 'PUT',
    body: JSON.stringify({ enabled }),
  });
}
